import { render } from "./app-list.vue?vue&type=template&id=2ca6397c"
import script from "./app-list.vue?vue&type=script&setup=true&lang=js"
export * from "./app-list.vue?vue&type=script&setup=true&lang=js"

import "./app-list.vue?vue&type=style&index=0&id=2ca6397c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/app-depart-layout/components/app-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ca6397c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ca6397c', __exports__)) {
    api.reload('2ca6397c', __exports__)
  }
  
  module.hot.accept("./app-list.vue?vue&type=template&id=2ca6397c", () => {
    api.rerender('2ca6397c', render)
  })

}


export default __exports__